/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Checkin_ConfirmedInputs */

const en_rental_checkin_confirmed = /** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in confirmed! We hope you enjoy your stay. 🏡`)
};

const es_rental_checkin_confirmed = /** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Check-in confirmado! Esperamos que disfrutes tu estancia. 🏡`)
};

const fr_rental_checkin_confirmed = /** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrivée confirmée ! Nous espérons que vous apprécierez votre séjour. 🏡`)
};

const de_rental_checkin_confirmed = /** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in bestätigt! Wir hoffen, du genießt deinen Aufenthalt. 🏡`)
};

const id_rental_checkin_confirmed = /** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in dikonfirmasi! Semoga Anda menikmati masa menginap Anda. 🏡`)
};

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const ja_rental_checkin_confirmed = en_rental_checkin_confirmed;

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const zh_rental_checkin_confirmed = en_rental_checkin_confirmed;

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const ar_rental_checkin_confirmed = en_rental_checkin_confirmed;

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const it_rental_checkin_confirmed = en_rental_checkin_confirmed;

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const ru_rental_checkin_confirmed = en_rental_checkin_confirmed;

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const pt_rental_checkin_confirmed = en_rental_checkin_confirmed;

/** @type {(inputs: Rental_Checkin_ConfirmedInputs) => LocalizedString} */
const ko_rental_checkin_confirmed = en_rental_checkin_confirmed;

/**
* | output |
* | --- |
* | "Check-in confirmed! We hope you enjoy your stay. 🏡" |
*
* @param {Rental_Checkin_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_checkin_confirmed = /** @type {((inputs?: Rental_Checkin_ConfirmedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Checkin_ConfirmedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_checkin_confirmed(inputs)
	if (locale === "es") return es_rental_checkin_confirmed(inputs)
	if (locale === "fr") return fr_rental_checkin_confirmed(inputs)
	if (locale === "de") return de_rental_checkin_confirmed(inputs)
	if (locale === "ja") return ja_rental_checkin_confirmed(inputs)
	if (locale === "zh") return zh_rental_checkin_confirmed(inputs)
	if (locale === "ar") return ar_rental_checkin_confirmed(inputs)
	if (locale === "id") return id_rental_checkin_confirmed(inputs)
	if (locale === "it") return it_rental_checkin_confirmed(inputs)
	if (locale === "ru") return ru_rental_checkin_confirmed(inputs)
	if (locale === "pt") return pt_rental_checkin_confirmed(inputs)
	return ko_rental_checkin_confirmed(inputs)
});